import { render, staticRenderFns } from "./upload-stock.vue?vue&type=template&id=14123577&"
import script from "./upload-stock.vue?vue&type=script&lang=js&"
export * from "./upload-stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports